export class SkinsConfig {
    shouldDisplayGrossOverall: string;
    shouldDisplayNetOverall: string;
}

export class Skin {
    hole: string;
    player: string;
    score: string;
    value: string;
}

export class AllSkins {
    collected: string;
    skin: Skin[];
}

export class SkinsSummary {
    player: any[];
}

export class Skins {
    skinsConfig: SkinsConfig;
    net_skins: AllSkins;
    gross_skins: AllSkins;
    skinsSummary:  SkinsSummary;
}

